import script from "./UiDetailList.vue?vue&type=script&setup=true&lang=js"
export * from "./UiDetailList.vue?vue&type=script&setup=true&lang=js"

import "./UiDetailList.vue?vue&type=style&index=0&id=60f5386a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60f5386a"]])

export default __exports__